module.exports = __webpack_public_path__ + "img/02.de107f85.jpg";